import { SHELL, SHELL_HISTORY } from '../../lib/api-routes'
import { createGetByIdAction } from './createGetByIdAction'

export const getShell = createGetByIdAction(SHELL)

export const getShellHistory = createGetByIdAction(SHELL_HISTORY)
